import { E_INVALID_URL } from "../Errors/index.js";
function parse(url) {
  try {
    const urlInfo = new URL(url);
    const urlParseResult = {
      protocol: urlInfo.protocol,
      host: urlInfo.host,
      hostName: urlInfo.hostname,
      port: urlInfo.port,
      path: urlInfo.pathname,
      queryObj: {},
      queryRaw: urlInfo.search,
      hash: decodeURI(urlInfo.hash).substring(1),
      hashRaw: urlInfo.hash
    };
    const query = decodeURI(urlParseResult.queryRaw).substring(1);
    for (const item of query.split("&")) {
      const [key, value] = item.split("=");
      if (key && value) urlParseResult.queryObj[key] = value;
    }
    return urlParseResult;
  } catch {
    throw new E_INVALID_URL();
  }
}
export {
  parse
};
//# sourceMappingURL=Parse.js.map
